import * as queryString from 'query-string'
import axiosVerbose from './axios/axiosVerbose'
import { logError } from './errors'

const legacyAffiliates = (location: Location, referrer: string) => () => {
  const query = queryString.parse(location.search)
  query.url = location.href
  query.referrer = referrer

  return axiosVerbose
    .get(`/affiliate/refer?${queryString.stringify(query)}`)
    .then(res => {
      if (res.data && res.data.redirect) {
        window.location.href = res.data.redirect_url
      }
    })
    .catch(logError)
}

export default legacyAffiliates
